import _ from 'lodash';
import { useEffect, useState } from 'react';
import { Stack, Button, Spinner } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { IFormTypeDetail } from '../../../commons/interfaces/form-type.interface';
import Paper from '../../../components/Paper';
import PublicFormInput from '../../../components/PublicFormInput';
import usePublicForm from '../../../hooks/publicForm.hook';
import FormService from '../../../services/form.service';
import PublicService from '../../../services/public.service';
import PlaceholderPublicForm from '../placeholder';

const formService = new FormService();
const publicService = new PublicService();

const MainForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue
  } = useForm({ criteriaMode: 'all' });
  const { customer, setStep } = usePublicForm();

  const params = useParams();
  const [formType, setFormType] = useState<IFormTypeDetail>();
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    const fetchFormTypeDetail = async () => {
      setLoading(true);

      const uniqueCode = params.formTypeId as string;
      const response = await formService.getFormType(uniqueCode);

      setFormType(response.data);
      setLoading(false);
    };

    fetchFormTypeDetail();
  }, [params.formTypeId]);

  const onSubmit = async (dataForm: Record<string, string | FileList>) => {
    try {
      setSubmitLoading(true);

      const responsesUploadPromise = _.map(dataForm, async (response, key) => {
        if (response instanceof FileList) {
          const files = await Promise.all(
            _.map(response, async (file) => {
              const url = await publicService.uploadFile(customer!.customerId, file);
              return url;
            })
          );

          const answer = files.join('|');

          return { questionId: key, answer };
        } else {
          return { questionId: key, answer: response };
        }
      });

      const responseUploadedFiles = await Promise.all(responsesUploadPromise);

      const requestData = {
        customerId: customer!.customerId,
        responses: responseUploadedFiles
      };

      const uniqueCode = params.formTypeId as string;
      await formService.createFormResponse(uniqueCode, requestData);

      setSubmitLoading(false);
      setStep(4);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <Stack gap={3} style={{ position: 'relative' }}>
        {submitLoading && (
          <div className="form-loader">
            <Spinner animation="border" />
          </div>
        )}
        {loading ? (
          <PlaceholderPublicForm />
        ) : (
          <>
            <Paper className="form-title">
              <div className="mb-2">
                <span className="text-title">{formType?.name}</span>
              </div>
              <div>
                <p>{formType?.description}</p>
              </div>
            </Paper>
            <Paper className="form-title">
              <div className="mb-2">
                <span className="text-subtitle">Información</span>
              </div>
              <div className="response-description">
                <div>
                  <b>Nombre del cliente: </b>
                  <span>{customer?.name}</span>
                </div>
                <div>
                  <b>Correo electrónico: </b>
                  <span>{customer?.email}</span>
                </div>
                <div>
                  <b>Número celular: </b>
                  <span>{customer?.number}</span>
                </div>
                <div>
                  <b>Nombre de la empresa: </b>
                  <span>{customer?.business.name}</span>
                </div>
                <div>
                  <b>RUC de la empresa: </b>
                  <span>{customer?.business.ruc}</span>
                </div>
              </div>
            </Paper>
            {_.map(formType?.questions, (question) => (
              <PublicFormInput
                key={question.id}
                register={register}
                questionId={question.id}
                question={`${question.order}. ${question.question}`}
                type={question.type}
                options={question.options}
                errors={errors}
                setValue={setValue}
              />
            ))}
          </>
        )}
      </Stack>

      <div className="form-footer mt-3">
        <Button variant="primary" type="submit" disabled={loading || submitLoading}>
          Enviar
        </Button>
      </div>
    </form>
  );
};

export default MainForm;
